module.exports = "https://static.web-purchase.prod.moonpig.net/_next/static/images/AppleHideEmail-c7a974326ceedc4b7b143ad4237569c1.svg";